import { Component, ViewEncapsulation, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PlessDialogServiceSub } from '../../kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { KYMW0909Model } from './kymw0909.model';
import { KYMW0909InputModel } from './vo/kymw0909-input.model';
import { KYMW0909OutputModel } from './vo/kymw0909-output.model';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { VersatileComboBoxComponent } from '../../kymw02/combo-box/versatile-combo-box/versatile-combo-box.component';
import { FlexGrid } from '@grapecity/wijmo.grid';

/**
 * ポイント交換商品プロモーション設定画面を管理するクラス
 *
 * @export KYMW0909Component
 * @class KYMW0909Component
 */
@Component({
  selector: 'app-kymw0909',
  templateUrl: 'kymw0909.component.html',
  styleUrls: ['kymw0909.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0909Component extends PlessViewHelperSub implements OnInit {
  param: any;
  setKYMW0909Parameter: Function;
  kymw0909Model: KYMW0909Model = new KYMW0909Model();
  
  // 取扱可能生協
  public enableCoopList = [];

  @ViewChild('cmb_MediumType', { static: true }) cmb_MediumType: VersatileComboBoxComponent;
  @ViewChild('dtg_CoopPointRateList', {static: true}) dtg_CoopPointRateList: FlexGrid;

  closeFunction: Function;

  isComposing = false;

  /**
   *Creates an instance of KYMW0909Component.
   * @param {PlessDialogServiceSub} dialogServiceSub
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0909Component
   */
  constructor(
    private dialogServiceSub: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0909';

    // 全選択チェック
    this.setCoopAllCheck();
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   */
  public setInterfaceParam(param: KYMW0909InputModel): void {
    this.kymw0909Model.mode = param.mode;
    if (this.isAddMode()) {
      // kymw0909から値を受け取る
      this.kymw0909Model.itemCodeList = param.itemCodeList;
      this.kymw0909Model.selectedItemCode = param.selectedItemCode;
      this.kymw0909Model.pointExchangeOrderNumQuotaCode = param.pointExchangeOrderNumQuotaCode;
      this.kymw0909Model.pointExchangeOrderNumQuotaCodeList = param.pointExchangeOrderNumQuotaCodeList;
      this.kymw0909Model.pointExchangeOrderNum = param.pointExchangeOrderNum;
      this.kymw0909Model.pointExchangeGoodsName = param.pointExchangeGoodsName;
      this.kymw0909Model.pointExchangeGoodsNameKana = param.pointExchangeGoodsNameKana;
      this.kymw0909Model.pointExchangeGuideName = param.pointExchangeGuideName;
      this.kymw0909Model.pointExchangeGuideNameKana = param.pointExchangeGuideNameKana;
      this.kymw0909Model.shortOfPointDiv = param.shortOfPointDiv;
      this.kymw0909Model.pointRateAllSetting = param.pointRateAllSetting;
      this.kymw0909Model.ecOnlyFlg = param.ecOnlyFlg === '1';
      this.kymw0909Model.consumeTaxRate = param.consumeTaxRate;
      this.kymw0909Model.consumeTaxDiv = param.consumeTaxDiv;
      this.kymw0909Model.coopPointRateList = param.coopPointRateList;
      this.kymw0909Model.registFlg = '1';
      this.kymw0909Model.deleteFlg = '0';
      this.kymw0909Model.coopInfoItemCoopCode = param.coopInfoItemCoopCode;
      // 登録済みのアイテムコードリスト
      this.kymw0909Model.settedItemCodeList = param.settedItemCodeList;

      // 変更前のアイテムコード
      this.kymw0909Model.beforeSelectedItemCode = this.kymw0909Model.selectedItemCode;
      // 初期表示状態のパラメータ
      this.kymw0909Model.firstPointExchangeOrderNumQuotaCode = this.kymw0909Model.pointExchangeOrderNumQuotaCode;
      this.kymw0909Model.firstPointExchangeOrderNum = this.kymw0909Model.pointExchangeOrderNum;
      this.kymw0909Model.firstPointExchangeGoodsName = this.kymw0909Model.pointExchangeGoodsName;
      this.kymw0909Model.firstPointExchangeGoodsNameKana = this.kymw0909Model.pointExchangeGoodsNameKana;
      this.kymw0909Model.firstPointExchangeGuideName = this.kymw0909Model.pointExchangeGuideName;
      this.kymw0909Model.firstPointExchangeGuideNameKana = this.kymw0909Model.pointExchangeGuideNameKana;
      this.kymw0909Model.firstShortOfPointDiv = this.kymw0909Model.shortOfPointDiv;
      this.kymw0909Model.firstEcOnlyFlg = this.kymw0909Model.ecOnlyFlg;
      this.kymw0909Model.firstPointRateAllSetting = this.kymw0909Model.pointRateAllSetting;
    } else if (this.isDetailMode() || this.isReadOnlyMode()) {
      // kymw0909から値を受け取る
      this.kymw0909Model.itemCodeList = param.itemCodeList;
      this.kymw0909Model.selectedItemCode = param.selectedItemCode;
      this.kymw0909Model.pointExchangeOrderNumQuotaCode = param.pointExchangeOrderNumQuotaCode;
      this.kymw0909Model.pointExchangeOrderNumQuotaCodeList = param.pointExchangeOrderNumQuotaCodeList;
      this.kymw0909Model.pointExchangeOrderNum = param.pointExchangeOrderNum;
      this.kymw0909Model.pointExchangeGoodsName = param.pointExchangeGoodsName;
      this.kymw0909Model.pointExchangeGoodsNameKana = param.pointExchangeGoodsNameKana;
      this.kymw0909Model.pointExchangeGuideName = param.pointExchangeGuideName;
      this.kymw0909Model.pointExchangeGuideNameKana = param.pointExchangeGuideNameKana;
      this.kymw0909Model.shortOfPointDiv = param.shortOfPointDiv;
      this.kymw0909Model.ecOnlyFlg = param.ecOnlyFlg === '1';
      this.kymw0909Model.consumeTaxRate = param.consumeTaxRate;
      this.kymw0909Model.consumeTaxDiv = param.consumeTaxDiv;
      this.kymw0909Model.pointRateAllSetting = param.pointRateAllSetting;
      this.kymw0909Model.coopPointRateList = param.coopPointRateList;
      this.kymw0909Model.registFlg = param.registFlg;
      this.kymw0909Model.deleteFlg = param.deleteFlg;
      this.kymw0909Model.coopInfoItemCoopCode = param.coopInfoItemCoopCode;

      // 登録済みのアイテムコードリスト（選択データを除いたもの）
      this.kymw0909Model.settedItemCodeList = param.settedItemCodeList.filter(_ => _ !== param.selectedItemCode);
    }
    this.kymw0909Model.coopPointRateCurrentList = param.coopPointRateCurrentList;

    this.setCoopAllCheck();
  }

  /**
   * 追加モードか判定
   */
  public isAddMode(): boolean {
    return this.kymw0909Model.mode === KYMW0909InputModel.MODE_ADD;
  }

  /**
   * 詳細モードか判定
   */
  public isDetailMode(): boolean {
    return this.kymw0909Model.mode === KYMW0909InputModel.MODE_DETAIL;
  }

  /**
   * 閲覧モードか判定
   */
  public isReadOnlyMode(): boolean {
    return this.kymw0909Model.mode === KYMW0909InputModel.MODE_READ_ONLY;
  }

  /**
   * アイテムコードイベントリスナ
   */
  public eventItemCode_CHANGEHandler(): void {
    // 確認ダイアログを表示する。
    this.dialogServiceSub.openAlertGetMessage('Q0174', [], e => {
      if (e === PlessAlert.Yes) {
        // 「はい」を選択した場合、追加ボタン押下時の初期表示状態で再描画する。
        this.kymw0909Model.pointExchangeOrderNumQuotaCode = this.kymw0909Model.firstPointExchangeOrderNumQuotaCode;
        this.kymw0909Model.pointExchangeOrderNum = this.kymw0909Model.firstPointExchangeOrderNum;
        this.kymw0909Model.pointExchangeGoodsName = this.kymw0909Model.firstPointExchangeGoodsName;
        this.kymw0909Model.pointExchangeGoodsNameKana = this.kymw0909Model.firstPointExchangeGoodsNameKana;
        this.kymw0909Model.pointExchangeGuideName = this.kymw0909Model.firstPointExchangeGuideName;
        this.kymw0909Model.pointExchangeGuideNameKana = this.kymw0909Model.firstPointExchangeGuideNameKana;
        this.kymw0909Model.shortOfPointDiv = this.kymw0909Model.firstShortOfPointDiv;
        this.kymw0909Model.ecOnlyFlg = this.kymw0909Model.firstEcOnlyFlg;
        this.kymw0909Model.pointRateAllSetting = this.kymw0909Model.firstPointRateAllSetting;
        // 選択したアイテムコードを変更前のアイテムコードとして保持
        this.kymw0909Model.beforeSelectedItemCode = this.kymw0909Model.selectedItemCode;

        // 会員生協チェックボックスの編集を行う	
        // 会員生協タブのアイテムコードに紐づく会員生協のチェックボックスにチェックを付ける
        const itemRelatedCoopList = this.kymw0909Model.coopInfoItemCoopCode.find(_ => _.itemCode === this.kymw0909Model.selectedItemCode)?.coopCode;
        // アイテムコードに紐づく生協コードが存在する場合はON、存在しない場合OFF
        for (const c of this.kymw0909Model.coopPointRateList) {
          if (itemRelatedCoopList) {
            c.PlanGoodsCoopPointRateEnableFlg = itemRelatedCoopList.includes(c.CoopCode);
          } else {
            c.PlanGoodsCoopPointRateEnableFlg = false;
          }
          // チェック変更時の処理を実行
          this.eventCoopPointRateListChk_CLICKHandler(c);
        }
        this.setCoopAllCheck();
      } else {
        // 「いいえ」を選択した場合、選択前のアイテムコードに戻し、確認ダイアログを閉じる。
        this.kymw0909Model.selectedItemCode = this.kymw0909Model.beforeSelectedItemCode;
      }
    });
  }

  /**
   * 全選択チェックボックス制御
   */
  public setCoopAllCheck(): void {
    // すべてのチェックボックスが活性でONの場合のみ全選択チェックボックスをON
    let flg = true;
    for (const c of this.kymw0909Model.coopPointRateList) {
      if (!c.PlanGoodsCoopPointRateEnableFlg && !c.DisabledFlg) {
        flg = false;
        break;
      }
    }
    this.kymw0909Model.planGoodsCoopPointRateEnableFlgAll = flg;
  }

  /**
   * 「閉じる」
   */
  public eventClose_CLICKHandler(): void {
    this.closeFunction();
  }

  /**
   * 設定ボタンを押下したときに呼び出されるメソッド。
   *
   * @param event コールバック・イベントへの参照
   */
  public eventSet_CLICKHandler(): void {
    if (!this.validate()) {
      return;
    }

    // 1物N価プロモーション情報設定モーダルの呼び出し元確認
    if (this.isAddMode()) {
        // 編集した内容で、1物N価媒体プロモーション設定情報一覧に行を追加する
        this.setParamsAndClose();
    } else if (this.isDetailMode()) {
      // 編集した内容で、1物N価媒体プロモーション設定情報一覧の内容を更新する
      this.setParamsAndClose()
    }
  }

  /**
   * 値をセットしてモーダルを閉じるメソッド
   */
  public setParamsAndClose(): void {
    // 親画面に反映
    const vo = new KYMW0909OutputModel();

    vo.selectedItemCode = this.kymw0909Model.selectedItemCode;
    vo.pointExchangeOrderNumQuotaCode = this.kymw0909Model.pointExchangeOrderNumQuotaCode;
    vo.pointExchangeOrderNum = this.kymw0909Model.pointExchangeOrderNum;
    vo.pointExchangeGoodsName = this.kymw0909Model.pointExchangeGoodsName;
    vo.pointExchangeGoodsNameKana = this.kymw0909Model.pointExchangeGoodsNameKana;
    vo.pointExchangeGuideName = this.kymw0909Model.pointExchangeGuideName;
    vo.pointExchangeGuideNameKana = this.kymw0909Model.pointExchangeGuideNameKana;
    vo.shortOfPointDiv = this.kymw0909Model.shortOfPointDiv;
    vo.ecOnlyFlg = this.kymw0909Model.ecOnlyFlg ? '1' : '0';
    vo.pointRateAllSetting = this.kymw0909Model.pointRateAllSetting;
    vo.coopPointRateList = this.kymw0909Model.coopPointRateList;
    vo.registFlg = this.kymw0909Model.registFlg;
    vo.deleteFlg = this.kymw0909Model.deleteFlg;
    this.setKYMW0909Parameter(vo);

    this.closeFunction();
  }

  /**
   * 設定ボタン押下時のバリデーション
   */
  private validate(): boolean {
    // 必須チェック
    if (this.isAddMode() && PlessViewUtilsSub.isEmpty(this.kymw0909Model.selectedItemCode)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['アイテムコード']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0909Model.pointExchangeOrderNumQuotaCode)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['注文コード割当コード']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0909Model.pointExchangeGoodsName)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['専用商品名']);
      return false;
    }
    if (PlessViewUtilsSub.isEmpty(this.kymw0909Model.shortOfPointDiv)) {
      this.dialogServiceSub.openAlertGetMessage('W0001', ['ポイント不足エラー区分']);
      return false;
    }

    // 登録済のアイテムコードの場合
    if (this.kymw0909Model.settedItemCodeList.includes(this.kymw0909Model.selectedItemCode)) {
      this.dialogServiceSub.openAlertGetMessage('E0270', [this.kymw0909Model.selectedItemCode]);
      return false;
    }

    // 会員生協が1生協も選択されていない場合
    let coopCheckFlg = true;
    for (const c of this.kymw0909Model.coopPointRateList) {
      if (c.PlanGoodsCoopPointRateEnableFlg) {
        // チェックされている場合はチェックのループ処理から脱出
        coopCheckFlg = true;
        break;
      } else {
        coopCheckFlg = false;
      }
    }
    if (!coopCheckFlg) {
      // 最後までチェックされていなかった場合
      this.dialogServiceSub.openAlertGetMessage('E0105', ['利用都県']);
      return false;
    }

    // チェックが付いている会員生協のポイント購入時割引率が空白の場合
    for (const c of this.kymw0909Model.coopPointRateList) {
      if (c.PlanGoodsCoopPointRateEnableFlg && c.PointRate === '') {
        this.dialogServiceSub.openAlertGetMessage('E0645', ['利用都県']);
        return false;
      }
    }

    return true;
  }

  /**
   * 会員生協別ポイント率一覧.全選択チェック処理
   */
  public eventCoopPointRateListAll_CLICKHandler(): void {
    const list = this.kymw0909Model.coopPointRateList;
    if (list != null) {
      list.forEach((item) => {
        item.PlanGoodsCoopPointRateEnableFlg = item.DisabledFlg ? false : this.kymw0909Model.planGoodsCoopPointRateEnableFlgAll;
      });
      // チェック処理に伴う変更を全ての生協に対して実行
      for (const i of list) {
        this.eventCoopPointRateListChk_CLICKHandler(i);
      }
    }
  }

  /**
   * 割引率一括設定押下処理
   */
  public eventDiscountRateSetting_CLICKHandler(pointRate: string): void {
    if (this.kymw0909Model.coopPointRateList) {

      const checkedItemList = this.kymw0909Model.coopPointRateList.filter(v => v.PlanGoodsCoopPointRateEnableFlg);

      if (PlessViewUtilsSub.isEmpty(pointRate)) {
        checkedItemList.forEach((item) => {
          item.PointRate = pointRate;
          item.ExchangePointWithoutTax = "";
          item.ExchangePoint = "";
        });
      } else {
        let pointRateNum = 0;
        switch (pointRate) {
          case '10':
            pointRateNum = 0.1;
            break;

          case '15':
            pointRateNum = 0.15;
            break;

          case '20':
            pointRateNum = 0.2;
            break;

          default:
            break;
        }

        checkedItemList.forEach((item) => {
          const supplyPrice = PlessViewUtilsSub.stringToNumber(
            PlessViewUtilsSub.editPriceComma(item.ThisTimeSupplyPrice, false)
          );

          // 小数点以下は切り捨て
          const exchangePointWithoutTax =
            Math.floor(supplyPrice - (supplyPrice * pointRateNum));

          // 交換ポイントの計算、小数点以下は切り捨て
          const exchangePoint =
            Math.floor(exchangePointWithoutTax * (1 + (this.kymw0909Model.consumeTaxRate / 100)));

          item.PointRate = pointRate;
          item.ExchangePointWithoutTax = PlessViewUtilsSub.editPriceComma(exchangePointWithoutTax, true);
          item.ExchangePoint = this.kymw0909Model.consumeTaxDiv === '0' ? PlessViewUtilsSub.editPriceComma(exchangePoint, true) : exchangePointWithoutTax;
        });
      }
    }
    this.dtg_CoopPointRateList.editableCollectionView.refresh();
  }

  /**
   * 会員生協別ポイント率一覧.チェック処理
   */
  public eventCoopPointRateListChk_CLICKHandler(selectedItem: any): void {
    // 全選択のチェック可否を設定
    this.setCoopAllCheck();

    if (selectedItem.PlanGoodsCoopPointRateEnableFlg) {
      // チェック：ポイント購入時割引率のプルダウンを活性にする。	チェック生協の削除フラグに1が設定されていた場合、0を設定する。
      selectedItem.DeleteFlg = '0';
      // データが追加データの場合は'1'、既にDBに登録済みのデータの場合は'0'を格納
      selectedItem.RegistFlg = this.kymw0909Model.coopPointRateCurrentList.find(_ => _.CoopCode === selectedItem.CoopCode) ? "0" : "1";
    } else {
      // チェック解除：ポイント購入時割引率のプルダウンをクリアし、非活性にする。チェック解除生協の削除フラグに1を設定する。
      selectedItem.PointRate = '';
      selectedItem.ExchangePointWithoutTax = '';
      selectedItem.ExchangePoint = '';
      selectedItem.DeleteFlg = '1';
      selectedItem.RegistFlg = '0';
    }

    this.dtg_CoopPointRateList.refresh();
  }

  /**
   * 会員生協別ポイント率一覧.ポイント購入時割引率選択処理
   */
  public eventPointRate_CLICKHandler(pointRate: string, index: number): void {
    const list = this.kymw0909Model.coopPointRateList;
    if (PlessViewUtilsSub.isEmpty(pointRate)) {
      list[index].ExchangePointWithoutTax = "";
      list[index].ExchangePoint = "";
    } else {
      let pointRateNum = 0;
      switch (pointRate) {
        case '10':
          pointRateNum = 0.1;
          break;

        case '15':
          pointRateNum = 0.15;
          break;

        case '20':
          pointRateNum = 0.2;
          break;

        default:
          break;
      }

      const supplyPrice = PlessViewUtilsSub.stringToNumber(
        PlessViewUtilsSub.editPriceComma(list[index].ThisTimeSupplyPrice, false)
      );

      // 小数点以下は切り捨て
      const exchangePointWithoutTax =
        Math.floor(supplyPrice - (supplyPrice * pointRateNum));

      // 交換ポイントの計算、小数点以下は切り捨て
      const exchangePoint =
        Math.floor(exchangePointWithoutTax * (1 + (this.kymw0909Model.consumeTaxRate / 100)));

      list[index].ExchangePointWithoutTax = PlessViewUtilsSub.editPriceComma(exchangePointWithoutTax, true);
      list[index].ExchangePoint = this.kymw0909Model.consumeTaxDiv === '0' ? PlessViewUtilsSub.editPriceComma(exchangePoint, true) : exchangePointWithoutTax;
    }
    this.dtg_CoopPointRateList.editableCollectionView.refresh();
  }

  /**
   * 専用商品名(カナ)の入力から半角カンマを削除
   */
  public eventPointExchangeGoodsNameKana_deleteCommaHandler(): void {
    this.kymw0909Model.pointExchangeGoodsNameKana = this.kymw0909Model.pointExchangeGoodsNameKana.replace(/,/g, '');
  }

  /**
   * 専用規格名(カナ)の入力から半角カンマを削除
   */
  public eventPointExchangeGuideNameKana_deleteCommaHandler(): void {
    this.kymw0909Model.pointExchangeGuideNameKana = this.kymw0909Model.pointExchangeGuideNameKana.replace(/,/g, '');
  }

  onCompStart() {
    this.isComposing = true;
  }
  // 全角入力から半角カンマに変換した時に削除するためのメソッド
  onCompDeleteCommaEnd(e: Event) {
    this.isComposing = false;
    (e.target as HTMLInputElement).value = (e.target as HTMLInputElement).value.replace(/,/g, '');
  }
}
